import { UserProfile, getUserProfileAsync } from '@chr/online-shared-microsite-core';

export const retrieveUserProfile = async (): Promise<UserProfile> => getUserProfileAsync();
